import {
    GET_AVATAR,
    GET_DOCUMENT_TOKEN,
    GET_OFFLINE_DOCUMENT_TOKEN,
    DELETE_DOCUMENT_TOKEN,
    PAIR_COMPANY,
    GET_COMPANIES,
    GET_GROUPS,
    GET_PROFILE,
    PUT_PROFILE,
    REQUEST_FORGOTTEN,
    REQUEST_LOGIN,
    REQUEST_VERIFYUSERPORTALTOKEN,
    REQUEST_ISUSERNAMEUNIQUE,
    REQUEST_REGISTER,
    REQUEST_VERIFYUSERPORTALPASSWORDTOKEN,
    REQUEST_RESET_PASSWORD,
    CAST_VOTE,
    LIST_MEETINGS,
    LIST_GROUP_MEETINGS,
    REQUEST_GOVERNANCE,
    GET_VOTE,
    GET_DOC,
    PUT_AVATAR,
    RESPONSE_ATTENDANCE,
    RESPONSE_MEETING_AUTHORISATION,
    RESPONSE_VOTING_AUTHORISATION,
    SET_NOTES,
    GET_NOTES,
    GET_WAR,
    GET_CAPTCHA,
    PASSWORD_TOKEN_GONE,
    REQUEST_LOCAL_HOST,
    LOG_ERROR,
    DOC_READ,
    DOC_SHARING,
    DOC_NATIVE,
    GET_PING,
    OFFLINE_ACCESS_TOKEN,
    GET_COMPANY_TASKS,
    EDIT_TASK_STATUS,
    GET_COMPANY_TASKS_USERS,
    GET_COMPANY_TASKS_CATEGORIES,
    LIST_GROUP_VOTES,
    LIST_GROUP_TASKS
    // LOG_DOCUMENT_READ,
} from './constants';
// import _ from 'lodash';
import store from '../stores/store';

function ApiError(name, message, spread = {}) {
    // console.log("ApiError", {name, message, spread});

    this.name = name;
    this.message = message || 'Default Message';
    this.spread = spread;

    if (window.offlineApiExtension && window.offlineApiExtension.isOnline()) {
        //IHT: bandaid to work around when already on the login PASSWORD_TOKEN_GONE
        if (spread.error && spread.error.toLowerCase() === 'invalid user credentials') {
            // store.user.logout();
            store.user.askToReauthenticate();
        }
    }

    const InstanceId = store.companies.selectedId;
    const userToken = store.user.token;

    // We first loop through the response
    let combineMessage = '';

    Object.keys(spread).map((keyName, keyIndex) => {
        // use keyName to get current key's name
        // and a[keyName] to get its value
        combineMessage = `${combineMessage + keyName}=${spread[keyName]}\n`;

        if (typeof spread[keyName] === 'object' && spread[keyName] !== null) {
            Object.keys(spread[keyName]).map((keyName1, keyIndex1) => {
                combineMessage = `${combineMessage + keyName1}=${spread[keyName][keyName1]}\n`;
            });
        }

        if (spread[keyName].type === 'cors') {
            for (const key in spread.statusResponse) {
                combineMessage = `${combineMessage + key}=${spread.statusResponse[key]}\n`;
            }
        }
    });

    const errorMessage = combineMessage;

    const params = {
        InstanceId,
        errorMessage,
    };

    // We log this so Indra can deal with it!! hahahaha..
    try {
        //IHT: if offline or can't log, would really like to save locally and sync later
        if (
            store.conn.checkOnlineStatus() &&
            userToken !== null &&
            userToken !== OFFLINE_ACCESS_TOKEN
        ) {
            const errorEndpoint = getApiEndpoint(LOG_ERROR);
            if (name.indexOf(errorEndpoint) === -1) {
                apiFetchPost(LOG_ERROR, userToken, params).catch(error => {
                    console.log('Failed to log error', error);
                });
            }
        }
    } catch (error) {
        console.log('Failed sending log error to server', error);
    }

    // this.stack = (new Error()).stack;
}
ApiError.prototype = Object.create(Error.prototype);
ApiError.prototype.constructor = ApiError;

// const host = process.env.NODE_ENV === "development" ? "https://w3dev12.boardtrac.com.au" : "https://test12.boardtrac.com.au";

const retrieveHost = () => {
    switch (window.location.hostname) {
        case 'localhost':
            // return 'https://w3dev12.boardtrac.com.au';
            //return 'https://pentest-clients-nopr.boardtrac.com.au';
             return 'http://localhost:51445';
           // return 'https://wa-test-boardtrac.azurewebsites.net';
            //return 'https://prerelease.boardtrac.com.au';
           // return 'https://prerelease-clients.boardtrac.com.au'

        //TEST
        case 'wa-test-boardtrac-webapp.azurewebsites.net':
            return 'https://wa-test-boardtrac.azurewebsites.net'
        //STABLE (only available ad hoc)
        case 'appsvc-bt-stable-webapp.azurewebsites.net':
            return 'https://appsvc-bt-stable-admin.azurewebsites.net'

        //PRERELEASE
        case 'prerelease-users.boardtrac.com.au':
            return 'https://prerelease-clients.boardtrac.com.au';

        //LIVE
        case 'wa-ase-boardtrac-prd-webapp-bt-webapp-deploy.azurewebsites.net':
            return 'https://wa-ase-boardtrac-prd-bt-admin-portal-deploy.azurewebsites.net';

        case 'pentest-users.boardtrac.com.au':
            return 'https://pentest-clients.boardtrac.com.au';
        
        case 'pentest-users-nopr.boardtrac.com.au':
            return 'https://pentest-clients-nopr.boardtrac.com.au';    

        case 'users-az.boardtrac.com.au':
            return 'https://clients-az.boardtrac.com.au';

        case 'users.boardtrac.com.au':
            return 'https://clients.boardtrac.com.au';

        default:
            //NB: electron isn't a browser, so need to specify per server
            if (window.require) {
                const lowerCaseName = window
                    .require('electron')
                    .remote.app.getName()
                    .toLowerCase();

                if (lowerCaseName.includes('prerelease')) {
                    return 'https://prerelease-clients.boardtrac.com.au';
                } else if (lowerCaseName.includes('test')) {
                    return 'htpps://wa-test-boardtrac.azurewebsites.net';
                } else if (lowerCaseName.includes('dev')) {
                    return 'http://localhost:51445';
                }
            }

            return 'https://clients.boardtrac.com.au';
    }
};

const retrieveLinkToDownloadHost = fileName => {
    return host + '/Content/boardtrac/' + fileName;
};

export const host = retrieveHost();

if (window.offlineApiExtension) {
    window.offlineApiExtension.set('host', host);
    // console.log("host:", window.offlineApiExtension.host);
}

// end points
export function getApiEndpoint(type, params = {}) {
    switch (type) {
        case GET_COMPANIES:
            return `${host}/api/v1/companies/`;

        case GET_GROUPS:
            return `${host}/api/v1/groups/${params.instanceId}/`;

        case GET_PROFILE:
            return `${host}/api/v1/profile/`;

        case GET_CAPTCHA:
            return `${host}/api/v1/getCaptcha/`

        case GET_VOTE:
            return `${host}/api/v1/voting/${params.instanceId}/`;

        case LIST_GROUP_VOTES:
            return `${host}/api/v1/voting/${params.instanceId}/group/${params.groupId}`;

        case GET_WAR:
            return `${host}/api/v1/reading`;

        case PUT_PROFILE:
            return `${host}/api/v1/profile/edit`;

        case REQUEST_LOGIN:
            return `${host}/token`;

        case GET_DOCUMENT_TOKEN:
            return `${host}/api/v1/adddocumenttoken`;

        case GET_OFFLINE_DOCUMENT_TOKEN:
            return `${host}/api/v1/generateudk`;

        case DELETE_DOCUMENT_TOKEN:
            return `${host}/api/v1/deletedocumenttoken`;

        case GET_AVATAR:
            return `${host}/api/v1/avatar/get/{fileName}`;

        case PUT_AVATAR:
            return `${host}/api/v1/avatar/edit`;

        case REQUEST_FORGOTTEN:
            return `${host}/api/v1/forgottenpassword`;

        case PAIR_COMPANY:
            return `${host}/api/v1/paircompany`;

        case REQUEST_VERIFYUSERPORTALTOKEN:
            return `${host}/api/v1/verifyuserportaltoken`;

        case REQUEST_ISUSERNAMEUNIQUE:
            return `${host}/api/v1/isusernameunique`;

        case REQUEST_REGISTER:
            return `${host}/api/v1/register`;

        case REQUEST_VERIFYUSERPORTALPASSWORDTOKEN:
            return `${host}/api/v1/verifyuserportalpasswordtoken`;

        case REQUEST_RESET_PASSWORD:
            return `${host}/api/v1/resetpassword`;

        case LIST_MEETINGS:
            return `${host}/api/v1/meetings/${params.instanceId}/`;

        case LIST_GROUP_MEETINGS:
            return `${host}/api/v1/meetings/${params.instanceId}/group/${params.groupId}`;

        case REQUEST_GOVERNANCE:
            return `${host}/api/v1/governance/${params.id}/group/${params.groupId}`;

        case RESPONSE_ATTENDANCE:
            return `${host}/api/v1/attendance`;

        case RESPONSE_MEETING_AUTHORISATION:
            return `${host}/api/v1/meetingauthorisation`;

        case RESPONSE_VOTING_AUTHORISATION:
            return `${host}/api/v1/votingauthorisation`;

        case CAST_VOTE:
            return `${host}/api/v1/voting`;

        case GET_DOC:
            return `${host}/api/v1/docwebview/${params.instanceId}/${params.docTypeId}/${
                params.docId
            }`;

        case SET_NOTES:
            return `${host}/api/v1/doc/notes`;
        case GET_NOTES:
            return `${host}/api/v1/doc/notes/${params.InstanceId}/${params.DocElementType}/${
                params.DocumentId
            }`;

        case REQUEST_LOCAL_HOST:
            return `${host}?token=${params.pin}`;

        case LOG_ERROR:
            return `${host}/api/v1/logerror`;

        case DOC_READ:
            return `${host}/api/v1/doc/logread/${params.instanceId}/${params.docId}/${
                params.docTypeId
            }/${params.date}`;

        case DOC_SHARING:
            return `${host}/api/v1/doc/capturedocumentaccess/${params.instanceId}/${params.docId}/${
                params.docTypeId
            }/${params.date}`;

        case GET_PING:
            return `${host}/ping/`;

        case GET_COMPANY_TASKS:
            return `${host}/api/v1/task/${params.instanceId}`;

        case LIST_GROUP_TASKS:
            return `${host}/api/v1/task/${params.instanceId}/group/${params.groupId}`;

        case GET_COMPANY_TASKS_USERS:
            return `${host}/api/v1/users/${params.instanceId}`;

        case GET_COMPANY_TASKS_CATEGORIES:
            return `${host}/api/v1/categories/${params.instanceId}`;

        case EDIT_TASK_STATUS:
            return `${host}/api/v1/task`;

        case DOC_NATIVE:
            return `${host}/docwebviewnative/${params.instanceId}/${params.docType}/${params.documentId}`

        default:
            return '';
    }
}

// EXE and DMG file links to download from SignIn page
export const WINDOWS_EXE_ELECTRON_LINK = retrieveLinkToDownloadHost('btp.exe');
export const MAC_DMG_ELECTRON_LINK = retrieveLinkToDownloadHost('btp.zip');

// common error handling

async function fetchWithErrorHandling(...args) {
    // console.log("fetchWithErrorHandling", {args});
    if (window.offlineApiExtension) {
        // debugger
        let hookResponse = await window.offlineApiExtension.beforeFetch(args);
        // debugger
        // console.log('api hookResponse', hookResponse);
        if (hookResponse && hookResponse.changeResponse) {
            return hookResponse.response;
        }
    }

    let responseError = '';

    // quick check to see if "offline" needs to be flicked to "online"
    if (!store.conn.isOnline) {
        store.conn.checkOnlineStatus();
    }

    return fetch(...args)
        .then(response => {
            // TODO Need to decide how to handle global errors

            if (response.status > 200) {
                responseError = {
                    status: response.status,
                    statusText: response.statusText,
                };
            }

            const contentType = response.headers.get('content-type');

            if (contentType && contentType.indexOf('application/json') !== -1) {
                return response.json();
            } else {
                let j = { error: 'error', message: 'message' };
                return j;
            }
        })
        .then(json => {
            if (typeof responseError === 'string') {
                // success

                if (window.offlineApiExtension) {
                    let hookResponse = window.offlineApiExtension.afterFetch(args, json);
                    if (hookResponse && hookResponse.changeResponse) {
                        json = hookResponse.response;
                    }
                }

                if (json.Decryption !== undefined && json.Decryption === PASSWORD_TOKEN_GONE) {
                    // store.user.logout();
                }

                return json;
            }
            // failed

            responseError = {
                ...json,
            };

            throw new ApiError(args[0], 'bad status', responseError);
        })
        .catch(async error => {
            //if not token/key gumph, go to the offline extension (if (keyName !== 'token' && keyName !== 'api/v1/generateudk') {)
            const arrUrl = args[0].split('/');
            const keyName =
                arrUrl[arrUrl.length - 1] !== undefined ? arrUrl[arrUrl.length - 1] : '';

            if (error instanceof TypeError && error.message === 'Failed to fetch') {
                //"Failed to fetch" = no connection or something more, but no response from server
                // console.log('fetch error', ...args);
                if (keyName !== 'token') {
                    store.conn.checkOnlineStatus();
                }
            }

            if (keyName !== 'token') {
                if (window.offlineApiExtension) {
                    let hookResponse = await window.offlineApiExtension.fetchFromIdb(args);
                    if (hookResponse && hookResponse.changeResponse) {
                        return hookResponse.response;
                    }
                    // IHT: not sure if a fail here should return null or throw an error?  Needs an error for store.companies.pairCompany
                    // return null;
                }
                throw error;
            } else {
                //if its the "token" endpoint and the error is not "failed to Fetch"
                if (error.message !== 'Failed to fetch') {
                    throw error;
                }
            }
            return null;
        });
}

// private methods

export function apiFetchGet(type, token, params) {
    //console.log("apiFetchGet (type, token, params)", type, token, params);
    const headers = new Headers({
        Accept: '*/*',
        Authorization: `bearer ${token}`,
    });

    return fetchWithErrorHandling(getApiEndpoint(type, params), {
        method: 'get',
        headers,
    });
}

export function apiFetchPostJson(type, token, body) {
    const headers = new Headers({
        'Content-Type': 'application/json',
        Accept: '*/*',
        Authorization: `bearer ${token}`,
    });

    return fetchWithErrorHandling(getApiEndpoint(type), {
        method: 'post',
        headers,
        body,
    });
}

export function apiFetchPostJsonMulti(type, token, body) {
    const headers = new Headers({
        Authorization: `bearer ${token}`,
    });

    const data = new FormData();

    data.append('AvatarName', body);

    return fetchWithErrorHandling(getApiEndpoint(type), {
        method: 'post',
        headers,
        body: data,
    });
}

export function apiFetchPost(type, token, body, params) {
    const headers = new Headers({
        'Content-Type': 'application/json',
        Accept: '*/*',
        Authorization: `bearer ${token}`,
    });

    return fetchWithErrorHandling(getApiEndpoint(type, params), {
        method: 'post',
        headers,
        body: JSON.stringify(body),
    });
}

export function apiFetchPostUrlEncoded(type, token, body) {
    const headers = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: '*/*',
        Authorization: `bearer ${token}`,
    });

    return fetchWithErrorHandling(getApiEndpoint(type), {
        method: 'post',
        headers,
        body,
    });
}
export function apiFetchPostWithoutToken(type, body) {
    const headers = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: '*/*',
    });

    return fetchWithErrorHandling(getApiEndpoint(type), {
        method: 'post',
        headers,
        body,
    });
}
const avatarCache = {};
// for avatar
export async function apiFetchUrlGet(url, token) {
    if (url === null) {
        return Promise.resolve();
    }

    if (avatarCache[url]) {
        return new Promise((resolve, reject) => resolve(avatarCache[url]));
    }

    const headers = new Headers({
        //   'Accept': 'application/json',
        Accept: '*/*',
        Authorization: `bearer ${token}`,
    });

    let blob = null;

    if (window.offlineApiExtension) {
        let hookResponse = await window.offlineApiExtension.beforeFetchUrlGet({ url, token });
        if (hookResponse && hookResponse.changeResponse) {
            blob = hookResponse.response;
            if (!blob) return new Promise((resolve, reject) => resolve(null));
        }
    }

    try {
        if (blob === null) {
            let response = await fetch(url, { method: 'get', headers });

            if (response.status >= 401) {
                return new Promise((resolve, reject) => resolve(null));
                // throw new ApiError('Status error', 'User not authorized', {
                //     status: response.status,
                //     statusText: response.statusText,
                // });
            }

            blob = await response.blob();

            if (!blob.type.includes('image')) {
                return null;
            }
        }

        if (window.offlineApiExtension) {
            // save image response
            window.offlineApiExtension.afterFetchUrlGet({ url, token }, blob);
        }

        const newUrl = URL.createObjectURL(blob);
        avatarCache[url] = newUrl;
        return newUrl;
    } catch (error) {
        if (error instanceof TypeError && error.message === 'Failed to fetch') {
            store.conn.checkOnlineStatus();
        }

        if (window.offlineApiExtension) {
            let hookResponse = await window.offlineApiExtension.fetchUrlFromIdb({ url, token });
            if (hookResponse && hookResponse.changeResponse) {
                const newUrl = URL.createObjectURL(hookResponse.response);
                avatarCache[url] = newUrl;
                return newUrl;
            }
        }
        throw error;
    }
}

export async function apiDownloadNativeDoc(token, params){
    const headers = new Headers({
        Accept: '*/*',
        Authorization: `bearer ${token}`,
    });
    const url = `${host}/api/v1/docwebviewnative/${params.instanceId}/${params.docTypeId}/${
        params.docId
        }`

        const result = await fetch(url, { headers })
        const arrayBuffer = await result.arrayBuffer();

        return arrayBuffer
}

export async function apiFetchDoc(token, params) {
    const headers = new Headers({
        Accept: '*/*',
        Authorization: `bearer ${token}`,
    });
    const url = `${host}/api/v1/docwebview/${params.instanceId}/${params.docTypeId}/${
        params.docId
    }`;

    // console.log('Api fetch Doc');

    // if (window.offlineApiExtension && !store.conn.isOnline) {
    // console.log('apifetchdoc: window.offline', window.offlineApiExtension);
    if (window.offlineApiExtension) {
        // console.log('window offline aj');
        // Wheneven we are here, we want to return the result from indexedDB regardless of
        // is it null or not because we are offline and unable to do a real API request.
        // If it's null, we will return null as it will and should be catched in the caller of apiFetchDoc.

        // console.log('Going to beforeFetchDoc');
        const docKey = store.documents.buildDocKey(
            params.docTypeId,
            params.instanceId,
            params.docId,
        );
        const doc = await window.offlineApiExtension.beforeFetchDoc(docKey);
        // console.log('after beforefetchdoc: ', doc, params);

        if (doc) {
            window.offlineApiExtension.saveRead(params);
        }

        if (doc !== undefined) {
            return doc;
        }
    }

    try {
        // console.log('going to online');
        const response = await fetch(url, { headers });

        if (response.status === 410) {
            store.user.logout();
        }

        // console.log('Going to network to fetch doc');
        const contentType = response.headers.get('Content-type');
        const arrayBuffer = await response.arrayBuffer();

        let docResponse = { arrayBuffer, contentType, status: response.status };

        if (window.offlineApiExtension) {
            const docKey = store.documents.buildDocKey(
                params.docTypeId,
                params.instanceId,
                params.docId,
            );
            if ((docKey, arrayBuffer, contentType)) {
                // let hookResponse = window.offlineApiExtension.afterFetchDoc(
                window.offlineApiExtension.afterFetchDoc(docKey, arrayBuffer, contentType);
            }
        }
        return docResponse;
    } catch (error) {
        if (window.offlineApiExtension) {
            let isOnline = await store.conn.checkOnlineStatus();

            if (!isOnline) {
                return null;
            }
        }
        console.log('error in fetchDoc: ', error);
        throw error;
    }
}

// public methods

export function fetchSignIn(type, body) {
    const headers = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: '*/*',
    });

    return fetchWithErrorHandling(getApiEndpoint(type), {
        method: 'post',
        headers,
        body,
    });
}

// LOCAL HOST RELATED FUNCTIONS

export function apiFetchGetLocalServer(type, params) {
    const headers = new Headers({
        Accept: '*/*',
    });

    return fetchLocalHostWithErrorHandling(getApiEndpoint(type, params), {
        method: 'get',
        headers: headers,
    });
}

function fetchLocalHostWithErrorHandling(...args) {
    let responseError = '';
    return fetch(...args)
        .then(response => {
            // TODO Need to decide how to handle global errors
            if (response.status >= 400) {
                responseError = {
                    status: response.status,
                    statusText: response.statusText,
                };
            }

            return response.json();
        })
        .then(json => {
            if (typeof responseError === 'string') {
                //success
                return json;
            } else {
                // failed
                responseError = {
                    ...json,
                };
                throw new ApiError(args[0], 'bad status', responseError);
                // return 'error';
            }
        });
}



// WEBPACK FOOTER //
// ./src/helpers/api.js